import React, { useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/layout/Layout";
import { SEOHead } from "./components/SEOHead";

import LandingPage from "./pages/LandingPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import WhyIpFundersPage from "./pages/WhyIpFundersPage";
import RequestAccessPage from "./pages/RequestAccessPage";
import NDAPage from "./pages/NDAPage";
import StartupsPage from "./pages/StartupsPage";
import CorporatePage from "./pages/CorporatePage";
import InventorsPage from "./pages/InventorsPage";
import InvestorsPage from "./pages/InvestorsPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";

// Redirect /home to /
function RedirectToHome() {
  return <Navigate to="/" replace />;
}

// 404 Not Found page
function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-[#0f1f2e] mb-4">404</h1>
        <p className="text-xl text-slate-600 mb-8">Page not found</p>
        <a href="/" className="text-[#1e3a5f] hover:underline">Return to homepage</a>
      </div>
    </div>
  );
}

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SEOHead />
        <Toaster position="top-center" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/home" element={<RedirectToHome />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/why-ipfunders" element={<WhyIpFundersPage />} />
            <Route path="/request-access" element={<RequestAccessPage />} />
            <Route path="/nda" element={<NDAPage />} />
            <Route path="/startups" element={<StartupsPage />} />
            <Route path="/corporate" element={<CorporatePage />} />
            <Route path="/inventors" element={<InventorsPage />} />
            <Route path="/investors" element={<InvestorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            {/* Catch-all for 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
